import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Truck } from './truck.model';

@Injectable()
export class TrucksService {
    constructor(private http: HttpClient) {
    }

    get(site: string): Observable<Truck[]> {
        return this.http.get<Truck[]>('trucks', {
            params: new HttpParams().set('site', site)
        });
    }
}
